import cx from 'classnames';
import { useAtom } from 'jotai';
import useLoggedUser from '../../../../hooks/use-logged-user';
import { selectVehicleStepAtom, vehiclePickerOpen } from '../../../../state/vehicle';
import {
  brandAtom,
  modelAtom,
  partAtom,
  referenceAtom,
  versionAtom,
} from '../../../../hooks/use-picker-selection';
import { FunctionComponent } from 'react';
import FeaturedLink from '../../../ui/links/featured';
import useTranslation from 'next-translate/useTranslation';

const SetAlertInfo: FunctionComponent<{
  brand?: any;
  model?: any;
  version?: any;
  part?: any;
  reference?: any;
}> = ({ brand, model, version, part, reference }) => {
  const [, setVehiclePicker] = useAtom(vehiclePickerOpen);
  const [, setSelectedVehicleStep] = useAtom(selectVehicleStepAtom);
  const [, setPart] = useAtom(partAtom);
  const [, setReference] = useAtom(referenceAtom);
  const [, setBrandAtom] = useAtom(brandAtom);
  const [, setModelAtom] = useAtom(modelAtom);
  const [, setVersionAtom] = useAtom(versionAtom);
  const { t } = useTranslation();

  const user = useLoggedUser();

  const openVehiclePicker = () => {
    setPart(part ? {
      value: part?.slug,
      label: part?.name,
      is_pro_allowed: part?.is_pro_allowed,
      is_allowed: part?.is_allowed,
    } : null);

    setReference(reference || null);

    setBrandAtom(brand ? {
      ...(brand),
      value: brand?.slug,
      label: brand?.name,
    } : null);

    setModelAtom(model ? {
      ...model,
      value: model?.slug,
      label: model?.name,
    } : null);

    setVersionAtom(version ? {
      ...version,
      value: version?.slug,
      label: version?.name,
    } : null);

    if (user) {
      setSelectedVehicleStep('CREATE_PART_ALERT');
    } else {
      setSelectedVehicleStep('CREATE_PART_ALERT_LOGIN');
    }

    setVehiclePicker((prevValue) => !prevValue);
  };

  return (
    <FeaturedLink
      variant={'blackBold'}
      onClick={() => {
        openVehiclePicker();
      }}
      type="button"
      className={cx('inline-block', 'mb-4')}
    >
      {t('products:create-alert')}
    </FeaturedLink>
  );
};

export default SetAlertInfo;
